module.exports = __webpack_public_path__ + "static/img/payover.jpg";